import { render, staticRenderFns } from "./HighlightedSectionHeader.vue?vue&type=template&id=72f763c6&scoped=true&"
import script from "./HighlightedSectionHeader.vue?vue&type=script&lang=js&"
export * from "./HighlightedSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedSectionHeader.vue?vue&type=style&index=0&id=72f763c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f763c6",
  null
  
)

export default component.exports